import Vue from 'vue'
import App from './App.vue'
import router from './router'
Vue.config.productionTip = false
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
//注册全局自定义组件
import "./components/public/index.js";
//国际化
 //import  i18n  from "./language";
 import  {i18n}  from './language'

//自定义iview样式
// import "../public/css/Myiview.css";
import "../public/css/index.less";
//axios请求
import axios from 'axios'
import VueAxios from 'vue-axios'
import '../public/js/axios.js'
//import icon from "../public/js/icon.js";
import icon from "../static/iconfont/iconfont.js"
import * as echarts from 'echarts';

import store from './store.js'
import $ from 'jquery'

import { registerEnumFilters } from './js/enumFilters.js'
registerEnumFilters(Vue);
// import { Message } from 'view-design';

// axios.defaults.baseURL = 'https://demo.sdxny.cn/ChargePlatform';
Vue.use(VueAxios, axios)
Vue.use(echarts);

Vue.use(ViewUI);

ViewUI.Message.config({
	duration: 3.5
});
// Vue.prototype.$Message.duration = 4;
Vue.prototype.$axios = axios;
Vue.prototype.$base_api_url = 'https://charge.sdxny.cn/ChargePlatform';

// import VueI18n from 'vue-i18n'
// console.log(VueI18n)

/**
 * window.g_App =new Vue
 * export default 
 * 两种都可以使js应用vue全局注册的插件
 */
window.App=new Vue({
  store,
  router: router.router,
  i18n, 
  render: h => h(App),
}).$mount('#app')
